import { IconButton, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow, Typography } from "@material-ui/core";
import React from "react";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import { FollowUp } from "./FollowUps";
import { Formatter } from "../Util";
interface GridProps {
	Data: Array<FollowUp>;
	OpenRow: Function;
}

export function FollowUpsGrid(props: GridProps) {
	const [pageNumber, setPageNumber] = React.useState(1);

	const getRows = () => {
		const pn = pageNumber - 1;
		const startIdx = pn * 50;
		const endIdx = pageNumber * 50 - 1;

		return props.Data.slice(startIdx, endIdx);
	};

	return (
		<div style={{ overflowX: "auto", width: "100%" }}>
			<Table size="small" style={{ tableLayout: "fixed" }}>
				<TableHead>
					<TableRow>
						<TableCell>Building</TableCell>
						<TableCell>Date of Contract</TableCell>
						<TableCell>Follow Up Notes</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{getRows().map((x, idx) => (
						<TableRow
							key={x.FollowUpID}
							style={{ cursor: "pointer" }}
							onClick={() => {
								props.OpenRow(x);
							}}>
							<TableCell>{x.BuildingName}</TableCell>
							<TableCell>{Formatter(x.DateContract, "D")}</TableCell>
							<TableCell>{x.LastNote}</TableCell>
						</TableRow>
					))}
				</TableBody>
				<TableFooter>
					<TableRow>
						<TableCell colSpan={4}>
							<IconButton disabled={pageNumber === 1} onClick={() => setPageNumber(pageNumber - 1)}>
								<KeyboardArrowLeft></KeyboardArrowLeft>
							</IconButton>
							<Typography variant="body1" style={{ display: "inline" }}>
								{pageNumber}
							</Typography>
							<IconButton disabled={pageNumber === Math.ceil(props.Data.length / 50)} onClick={() => setPageNumber(pageNumber + 1)}>
								<KeyboardArrowRight></KeyboardArrowRight>
							</IconButton>
						</TableCell>
					</TableRow>
				</TableFooter>
			</Table>
		</div>
	);
}
